import { createContext, useEffect, useReducer } from "react";

import axios from "../utils/axios";
import { isValidToken, setSession } from "../utils/jwt";
import JWTReducer from "../reducers/JWTReducer";
import { SignInConstants } from "../constants/signin.constants";

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
  userMenus: [],
  employeeMenus: [],
  authUserAutoSearchResults: {
    data: [],
    paging: {
      hasNextPage: false,
      hasPreviousPage: false,
      pageNumber: 0,
      pageSize: 0,
      totalNumberOfPages: 0,
      totalNumberOfRecords: 0,
    },
  },
  isLoadingAutoSearch: true,
};

const AuthContext = createContext(null);

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(JWTReducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem("accessToken");

        if (accessToken && isValidToken(accessToken)) {
          setSession(accessToken);

          const response = await axios.get("/auth/my-account");

          console.log(response, "responseresponse");
          const user = response.data;

          console.log(user);

          dispatch({
            type: SignInConstants.INITIALIZE,
            payload: {
              isAuthenticated: true,
              user,
            },
          });
        } else {
          dispatch({
            type: SignInConstants.INITIALIZE,
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: SignInConstants.INITIALIZE,
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const signIn = async (username, password) => {
    const response = await axios.post("/auth/signin", {
      username,
      password,
    });
    const { token, user } = response.data;

    console.log(response, "responseresponse");

    setSession(token);
    dispatch({
      type: SignInConstants.SIGN_IN,
      // payload: {
      //   username: response.data.username,
      //   roles: [{ name: response.data.authorities[0]["authority"] }],
      // },
      payload: {
        username: response.data.username,
        businessType: response.data.authorities[0],
        tenantId: response.data.tenantId,
        name: response.data.name,
        radUserId: response?.data?.radUserId,
      },
    });
  };

  const signOut = async () => {
    setSession(null);
    dispatch({ type: SignInConstants.SIGN_OUT });
  };

  const signUp = async (username, password, firstName, lastName) => {
    const response = await axios.post("/api/auth/sign-up", {
      username,
      password,
      firstName,
      lastName,
    });
    const { accessToken, user } = response.data;

    window.localStorage.setItem("accessToken", accessToken);
    dispatch({
      type: SignInConstants.SIGN_UP,
      payload: {
        user,
      },
    });
  };

  const getUserMenusWithPermissions = async () => {
    try {
      dispatch({
        type: SignInConstants.FETCH_MENU_REQUEST,
      });
      const response = await axios.get("/auth/get-user-menu");

      dispatch({
        type: SignInConstants.FETCH_MENU_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: SignInConstants.FETCH_MENU_FAILURE,
      });
    }
  };
  const getUserMenusWithId = async (userName) => {
    try {
      dispatch({
        type: SignInConstants.FETCH_MENU_WITH_ID_REQUEST,
      });
      const response = await axios.get(`/auth/get-user-menu/with-tenant-username/${userName}`);

      dispatch({
        type: SignInConstants.FETCH_MENU_WITH_ID_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: SignInConstants.FETCH_MENU_WITH_ID_FAILURE,
      });
    }
  };
  const getUserMenusWithRoleId = async (roleId) => {
    try {
      dispatch({
        type: SignInConstants.FETCH_MENU_WITH_ROLE_ID_REQUEST,
      });
      const response = await axios.get(`/auth/get-user-menu/with-role-id/${roleId}`);

      dispatch({
        type: SignInConstants.FETCH_MENU_WITH_ROLE_ID_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: SignInConstants.FETCH_MENU_WITH_ROLE_ID_FAILURE,
      });
    }
  };
  const getUserMenusWithUserName = async (userName) => {
    try {
      const response = await axios.get(`/auth/get-user-menu/with-tenant-username/${userName}`);
      return response.data;
    } catch (exception) {
      console.log("Exception in fecthing user menu");
      return 0;
    }
  };
  const checkUserPermission = async (menuName, permission) => {
    try {
      const response = await axios.get("/auth/check-user-permission/" + menuName);
      return response.data;
    } catch (exception) {
      console.log("Exception in fecthing user menu");
      return 0;
    }
  };
  const autoSearchAuthUser = async (payload) => {
    try {
      const response = await axios.post("/auth/auto-search", payload);
      dispatch({
        type: SignInConstants.AUTH_USER_AUTO_SEARCH_REQUEST,
      });
      dispatch({
        type: SignInConstants.AUTH_USER_AUTO_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: SignInConstants.AUTH_USER_AUTO_SEARCH_FAILURE,
      });
    }
  };

  const resetPassword = (email) => console.log(email);

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: "jwt",
        signIn,
        signOut,
        signUp,
        resetPassword,
        getUserMenusWithPermissions,
        checkUserPermission,
        getUserMenusWithId,
        getUserMenusWithRoleId,
        autoSearchAuthUser,
        getUserMenusWithUserName,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
